module.exports = __webpack_public_path__ + "img/p2p.22454db5.jpg";